// Module Name for TSDocs
/**
 * [[include:component-library.md]]
 * @module Component Library
 */

import {
  AccordionComponent,
  ButtonComponent,
  ConfigureButtonComponent,
  DisclaimerComponent,
  DisclaimerReferenceComponent,
  DividerComponent,
  FaqListComponent,
  FlagComponent,
  GroupedSelectComponent,
  IconComponent,
  ImageComponent,
  InfoButtonComponent,
  InputComponent,
  LayerContainerComponent,
  LinkComponent,
  MultiSliderComponent,
  SelectComponent,
  SliderComponent,
  TabsComponent,
  TextComponent,
  ToggleComponent,
} from './components';
import {TableComponent} from './components/table';

export * from './components';

// this mock object is needed in order to have a proper value to be checked if a requested component is part ot the optional component library or not
export const mockOptionalEMobilityToolsFeatureAppComponentLibrary: OptionalEMobilityToolsFeatureAppComponentLibrary =
  {
    Tabs: undefined,
    ConfigureButton: undefined,
  };

interface OptionalEMobilityToolsFeatureAppComponentLibrary {
  readonly ConfigureButton?: ConfigureButtonComponent;
  readonly Tabs?: TabsComponent;
  readonly Table?: TableComponent;
}

/**
 * This interface defines all white label component types as API which should be implemented by each brand with their own design system.
 *
 * In many cases the components used by the brands don't need to be the same kind of component, they just need to fulfill the same purpose: While VW uses an [[Accordion]] component to display FAQs, another brand might use tabs, divs,...
 *
 * @category Component Library
 */
// TODO: Improve descriptions by adding links to general white label mapping approach. Improve documentation after API was refined together with Audi.
export interface EMobilityToolsFeatureAppComponentLibrary
  extends OptionalEMobilityToolsFeatureAppComponentLibrary {
  readonly Accordion: AccordionComponent;
  readonly Button: ButtonComponent;
  readonly ButtonInverted: ButtonComponent;
  readonly Disclaimer: DisclaimerComponent;
  readonly DisclaimerReference: DisclaimerReferenceComponent;
  readonly Divider: DividerComponent;
  readonly FaqList: FaqListComponent;
  readonly Flag: FlagComponent;
  readonly FlagInverted: FlagComponent;
  readonly GroupedSelect: GroupedSelectComponent;
  readonly Icon: IconComponent;
  readonly IconInverted: IconComponent;
  readonly Image: ImageComponent;
  readonly InfoButton: InfoButtonComponent;
  readonly InfoButtonInverted: InfoButtonComponent;
  readonly Input: InputComponent;
  readonly LayerContainer: LayerContainerComponent;
  readonly Link: LinkComponent;
  readonly MultiSlider: MultiSliderComponent;
  readonly Select: SelectComponent;
  readonly Slider: SliderComponent;
  readonly Text: TextComponent;
  readonly TextInverted: TextComponent;
  readonly Toggle: ToggleComponent;
}
